import { locationTrackerTypesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("location-tracker-type"),
  endpoint: "location-tracker-types",
  operations: locationTrackerTypesOps,
  roleView: [ROLE.LOC_TRACK_VIEW, ROLE.LOC_TRACK_ADMIN],
  roleAdmin: [ROLE.LOC_TRACK_ADMIN],

  singularName: (t) => t("Location tracker type"),
  name: (t) => t("Location trackers types"),
  syncCustomerFilter: true,
});

export default conf;
